;(function() {
  'use strict'

  Config.$inject = ["$stateProvider"];
  angular.module('app.contentGroups', []).config(Config)

  /* @ngInject */
  function Config($stateProvider) {
    $stateProvider.state('app.contentGroups', {
      url: '/content-groups',
      templateUrl: 'content-groups.html',
      controller: 'ContentGroups',
      controllerAs: '$ctrl',
    })
  }
})()
